import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { styles } from './Divider.scss';

const cx = classNames.bind(styles);

export const Divider = ({ children, variant, type, className, ...props }) => {
  const classes = cx(
    'c-divider',
    {
      [`c-divider--${variant}`]: variant,
      [`c-divider--type-${type}`]: type,
    },
    className,
  );

  const lineClasses = cx('c-divider__line', {
    [`c-divider__line--${variant}`]: variant,
    [`c-divider__line--${type}`]: type,
  });

  const textClasses = cx('c-divider__text', {
    [`c-divider__text--${type}`]: type,
  });

  return (
    <div className={classes} {...props}>
      <hr className={lineClasses} />
      {children && <span className={textClasses}>{children}</span>}
    </div>
  );
};

Divider.propTypes = {
  variant: PropTypes.oneOf([
    'default',
    'primary',
    'tertiary',
    'secondary',
    'tenacious',
  ]),
  type: PropTypes.oneOf(['horizontal', 'vertical']),
  className: PropTypes.string,
  children: PropTypes.any,
};

Divider.defaultProps = {
  variant: 'default',
  type: 'horizontal',
  className: '',
};
